import { Instagram, Linkedin, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="w-full bg-muted/30 text-muted-foreground border-t border-border mt-0 pt-6 pb-3">
    <div className="max-w-7xl mx-auto px-4 flex flex-col gap-3">
      {/* Logos y social icons en una sola fila, responsive */}
      <div className="flex flex-col md:flex-row items-center justify-between w-full gap-6 md:gap-0">
        {/* Logo Grupo Jade separado */}
        <div className="flex items-center justify-center mb-3 md:mb-0 md:pr-6 md:border-r border-border min-w-[100px]">
          <img
            src="/assets/grupo-jade-red.svg"
            alt="Grupo Jade"
            className="h-16 md:h-20 w-auto"
          />
        </div>
        {/* Demás logos */}
        <div className="flex flex-col lg:flex-row items-center lg:items-end gap-4 md:gap-6 px-0 md:px-6 mb-3 md:mb-0">
          <img
            src="/assets/teriyaki_red.svg"
            alt="Teriyaki"
            className="h-8 w-48 opacity-60 hover:opacity-80 transition-opacity brightness-0"
          />
          <img
            src="/assets/zen_white.svg"
            alt="Zen"
            className="h-8 w-48 opacity-60 hover:opacity-80 transition-opacity brightness-0"
          />
          <img
            src="/assets/tamashi_red.svg"
            alt="Tamashi"
            className="h-8 w-48 opacity-60 hover:opacity-80 transition-opacity brightness-0"
          />
        </div>
        {/* Iconos sociales */}
        <div className="flex gap-4 md:pl-6 md:border-l border-border min-w-[100px]">
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noopener"
            className="hover:text-primary transition-colors duration-150"
            aria-label="LinkedIn"
          >
            <Linkedin size={18} />
          </a>
          <a
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener"
            className="hover:text-primary transition-colors duration-150"
            aria-label="Instagram"
          >
            <Instagram size={18} />
          </a>
          <a
            href="mailto:info@grupojade.com"
            className="hover:text-primary transition-colors duration-150"
            aria-label="Email"
          >
            <Mail size={18} />
          </a>
        </div>
      </div>
      {/* Texto final centrado debajo de todo */}
      <div className="w-full flex flex-col items-center mt-2">
        <span className="text-xs text-muted-foreground/70 text-center">
          GRUPO JADE ® {new Date().getFullYear()} | POWERED BY REISP SOLUTIONS
        </span>
      </div>
    </div>
  </footer>
);
